import "./ScrollUpBtn.css";
import { FaChevronUp } from "react-icons/fa6";
import { useState, useEffect } from "react";

export default function ScrollUpBtn() {
  const [scrollY, setScrollY] = useState(0);

  function ScrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  if (scrollY > 20)
    return (
      <div
        className="ScrollUpBtn"
        style={{ opacity: (scrollY - 19) / 100 }}
        onClick={ScrollToTop}
      >
        <FaChevronUp size={"4vh"} />
      </div>
    );
}
